import { LayerStyleGenerator } from '../layer/layer-style-generator';
import { LineStyle, StyleSymbol, SymbologyOverrideChoice, SymbolOverrideDTO } from './style-symbology';

export class Style {
    name = '';
    image = '';
    lineColor: number = 0xda212c;
    lineWeight = 5;
    lineStyle = LineStyle.SOLID;
    fillColor: number = 0xda212c;
    fillOpacity = 20;
    symbolId = '';
    id = '';
    symbol = new StyleSymbol();
    styleOverrides: SymbologyOverrideChoice[] | SymbolOverrideDTO[] = [];

    constructor(style?: Style) {
        if (style) {
            this.setStyle(style);
        }
    }

    public setColor(color: string): void {
        let colorNumber = parseInt(color.replace('#', '0x'), 16);
        this.fillColor = colorNumber;
        this.lineColor = colorNumber;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public setStyle(style: Style): void {
        this.name = style.name;
        this.image = style.image;
        this.lineColor = style.lineColor;
        this.lineWeight = style.lineWeight;
        this.lineStyle = style.lineStyle;
        this.fillColor = style.fillColor;
        this.fillOpacity = style.fillOpacity;
        this.symbolId = style.symbolId;
        this.id = style.id;
        this.symbol = style.symbol || new StyleSymbol();
        this.styleOverrides = style.styleOverrides?.map(override => {
            return Style.fromStyleOverrideDTO(override as SymbolOverrideDTO);
        });
    }

    public formatStyle() {
        if (typeof this.fillColor === 'string') {
            this.fillColor = LayerStyleGenerator.hexToDecimalRgb(this.fillColor);
        }
        if (typeof this.lineColor === 'string') {
            this.lineColor = LayerStyleGenerator.hexToDecimalRgb(this.lineColor);
        }
    }

    static fromStyleOverrideDTO(override: SymbolOverrideDTO): SymbologyOverrideChoice {
        const parsedFilter = Style.parseFilter(override.filter);
        return {
            id: override.id,
            choiceField: parsedFilter.choiceField,
            choiceValue: parsedFilter.choiceValue,
            lineColor: override.styleOverride.lineColor,
            fillColor: override.symbolOverride.fillColor,
            outlineColor: override.symbolOverride.outlineColor,
            color: override.symbolOverride.color
        };
    }

    static parseFilter(filter: string) {
        const match = filter.match(/^\$(.+) EQ (.+)$/);
        if (match) {
            return {
                choiceField: match[1],
                choiceValue: match[2].replace(/'/g, '')
            };
        }
        return null;
    }
}
